export const environment = {
    production: false,
    debug: false,
    apiUrl: '/api',
    pdfUrl: 'https://vwb-app-risicomonitor-backend-tst.azurewebsites.net/api',//'https://api.prm.bvgo.tst.recognize.dev/api',
    azureMapsKey: '6JZz65YNlEcSZ8E9RPwZnmNS0xMYuK1kpHUs93UuGvNfbzkHFHw9JQQJ99CIAC5RqLJ16m6LAAAgAZMP3BNt',
    applicationInsights: {
        instrumentationKey: '4bc02fee-0982-48d9-bab5-65857ee2214e'
    },
    msAuth: {
        issuer: 'https://login.microsoftonline.com/common/v2.0',
        clientId: 'a27071b1-8681-4b80-9da0-def1a2bbf8d3',
        redirectUri: `${window.location.origin}/msal-auth`,
        scopes: ['api://a27071b1-8681-4b80-9da0-def1a2bbf8d3/user.read'],
        redirectToExternalEndSessionEndpointAfterLogout: false,
        redirectRoute: {
            afterAuthentication: ['/'],
            noAuthentication: ['/no-access'],
            failedAuthentication: ['/error']
        },
        // Use LocalStorage to allow same authentication across multiple browser tabs and persistence of tokens
        sessionStorageDriver: localStorage
    },
    features: {
        accessibleSteps: {
            enabled: true,
            showSetToDefaultButton: true // Useful for testing / debugging
        },
        apiProjectCreation: {
            enabled: true
        }
    }
};
